import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wl-card',
  templateUrl: './card.component.html',
  styles: [`
  mat-card {
    margin: 16px;
    padding: 0;
    border-radius: 0;
  }
  mat-card-content {
    padding: 24px;
  }
  h3 {
    margin: 0;
    background-color: #3493D8;
    background: linear-gradient(90deg, #db2016 0%, #00569d 100%);
    padding: 16px;
    color: #fff;
  }
`]
  // styles: [`
  //   mat-card {
  //     margin: 16px;
  //   }
  // `]
})
export class CardComponent {

  @Input() showHeading: boolean = true;
  @Input() heading: string;
  @Input() subheading1: string;
  @Input() subheading2: string;
  @Input() showInput : boolean = false;
  @Input() inputPlaceholder='Enter value'
  @Input() showCheckbox:boolean = false;
  @Input() checkboxLabel:string ='I agree';
  @Output() inputValueChange = new EventEmitter<string>();
  @Output() checkboxChange =new EventEmitter<boolean>();

  inputValue: string =''
  checkboxValue:boolean = false; 

  constructor() { }

  onInputChange(value:string){
    this.inputValueChange.emit(value);
  }

  onCheckboxChange(value:boolean){
    this.checkboxChange.emit(value);
  }
}
